import { render } from "./SavingNotification.vue?vue&type=template&id=21c4c73c&scoped=true&ts=true"
import script from "./SavingNotification.vue?vue&type=script&lang=ts"
export * from "./SavingNotification.vue?vue&type=script&lang=ts"

import "./SavingNotification.vue?vue&type=style&index=0&id=21c4c73c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c4c73c"]])

export default __exports__